import { RootState } from 'app/store';

export const selectPendingEvaluationsCount = (state: RootState) =>
  state.pendingEvaluations.pendingEvaluationsCount;
export const selectIsLoadingPendingEvaluations = (state: RootState) =>
  state.pendingEvaluations.isLoadingPendingEvaluations;
